import { Center, Spinner } from '../atoms';
import React from 'react';

export const SecurityBoundary = ({
  children,
  fetching,
  fetchSession,
}: {
  fetching: boolean;
  fetchSession: () => Promise<void>;
  children?: React.ReactNode;
}) => {
  React.useEffect(() => {
    fetchSession();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (fetching)
    return (
      <Center>
        <Spinner variant="secondary" size="xlarge" />
      </Center>
    );

  return <React.Fragment>{children}</React.Fragment>;
};
